import React from "react";
import { SEO } from "../components/seo";

function App() {
  return (
    <>
      <SEO
        title="Booking - League Life | Book Services & Experiences"
        description="Book trusted services and curated experiences through League Life. Access in-app booking for dining, wellness, travel, and more."
        canonicalUrl="https://leaguelife.com/booking"
      />
      <main>
        <h1>
          Please open this link on a smartphone with the League Life app
          installed.
        </h1>
      </main>
    </>
  );
}

export default App;
